// extracted by mini-css-extract-plugin
module.exports = {"SRichText":"Ingress_SRichText__Gs_UV"};